/**
 * Centralized catalog of equipment unit/equipment statuses (v5.2.0).
 * Single source of truth for labels, colors, and dropdown options.
 */

// The 10 canonical statuses (NEW catalog)
export const CANONICAL_STATUSES = [
  'disponible',
  'asignado',
  'en_prestamo',
  'mantenimiento_interno',
  'mantenimiento_externo',
  'falla',
  'perdido_recuperar',
  'perdido_definitivo',
  'baja_perdida',
  'baja_definitivo',
];

// Legacy → canonical mapping. Used to render legacy values without breaking UI.
const LEGACY_STATUS_MAP = {
  mantenimiento: 'mantenimiento_interno',
  perdido: 'perdido_recuperar',
  baja: 'baja_definitivo',
};

// Spanish display labels
export const STATUS_LABELS = {
  disponible: 'Disponible',
  asignado: 'Asignado',
  en_prestamo: 'En Préstamo',
  mantenimiento_interno: 'Mantenimiento Interno',
  mantenimiento_externo: 'Mantenimiento Externo',
  falla: 'Con Falla',
  perdido_recuperar: 'Perdido a Recuperar',
  perdido_definitivo: 'Perdido Definitivo',
  baja_perdida: 'Dado de Baja por Pérdida',
  baja_definitivo: 'Dado de Baja Definitivo',
};

// Tailwind color tokens (badge-friendly: bg / text / border)
export const STATUS_COLORS = {
  disponible:            'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  asignado:              'bg-blue-500/20 text-blue-400 border-blue-500/30',
  en_prestamo:           'bg-purple-500/20 text-purple-400 border-purple-500/30',
  mantenimiento_interno: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  mantenimiento_externo: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  falla:                 'bg-red-500/20 text-red-400 border-red-500/30',
  perdido_recuperar:     'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  perdido_definitivo:    'bg-rose-600/20 text-rose-400 border-rose-600/30',
  baja_perdida:          'bg-slate-500/20 text-slate-400 border-slate-500/30',
  baja_definitivo:       'bg-zinc-700/30 text-zinc-300 border-zinc-700/40',
};

/** Map legacy status values to their canonical replacement. Pass-through for unknown/canonical. */
export const normalizeStatus = (s) => {
  if (!s) return s;
  const v = String(s).trim().toLowerCase();
  return LEGACY_STATUS_MAP[v] || v;
};

/** Get the Spanish label for any status value (legacy-tolerant). */
export const statusLabel = (s) => {
  const c = normalizeStatus(s);
  return STATUS_LABELS[c] || c || '';
};

/** Get the Tailwind badge class for any status value (legacy-tolerant). */
export const statusColor = (s) => {
  const c = normalizeStatus(s);
  return STATUS_COLORS[c] || 'bg-muted text-muted-foreground border-border';
};

/** Dropdown options for <Select> inputs (canonical only). */
export const STATUS_OPTIONS = CANONICAL_STATUSES.map((value) => ({
  value,
  label: STATUS_LABELS[value],
}));
